import { useNavigation } from '@react-navigation/native';
import React, { useEffect } from 'react';
import { ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { Modals } from '../../constants/ScreenNames';
import { getPageMessage } from '../../store/actions/mytrips';
import { selectPageMessages } from '../../store/selectors/mytrips.selector';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import BaseText from '../BaseText';
import { AntDesign } from '@expo/vector-icons';
import Icon from '../Icon';

const Messages = ({ companyKey, groupKey, pageKey }) => {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const messages = useSelector(selectPageMessages);
  useEffect(() => {
    async function getMessages() {
      await dispatch(getPageMessage(companyKey, groupKey, pageKey));
    }
    getMessages();
  }, []);
  return (
    <>
      {messages ? (
        <View testID="MessageContainer" style={styles.companyMessages}>
          {messages.map((msg, index) =>
            !msg.IsTimeLimit ||
            (msg.IsTimeLimit &&
              Date.now() >= Date.parse(msg.StartDate) &&
              Date.now() <= Date.parse(msg.EndDate)) ? (
              <View style={styles.msgContainer} key={index}>
                <ScrollView>
                  <TouchableOpacity
                    onPress={() =>
                      navigation.navigate(Modals.MessagesModal, { message: messages[index] })
                    }
                  >
                    <View style={styles.textContainer}>
                      <Icon
                        size={28}
                        name="message"
                        style={CommonStyles.mr3}
                        color={Color.primary}
                      />
                      <BaseText style={CommonStyles.h3}>{msg.MessageTitle}</BaseText>
                      <View style={CommonStyles.flex1}>
                        <AntDesign
                          style={CommonStyles.alignSelfToEnd}
                          name="caretright"
                          size={18}
                          color={Color.text.medium}
                        />
                      </View>
                    </View>
                  </TouchableOpacity>
                </ScrollView>
              </View>
            ) : null
          )}
        </View>
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  companyMessages: {
    ...CommonProperties.mt5,
  },
  msgContainer: {
    ...CommonProperties.p4,
    ...CommonProperties.mb3,
    ...CommonProperties.borderRadius,
    ...CommonProperties.shadow,
    backgroundColor: Color.accent,
  },
  textContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default Messages;
